var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ofIsGeneratingPdf"},[_vm._v("正在生成笔记，请您耐心等待一会。")])}
var staticRenderFns = []

export { render, staticRenderFns }